import React, { useState, useEffect } from 'react';

/**
 * TempoInput.jsx
 * A "Lazy Validator" input for tempo.
 * Allows free typing, validating only on Blur or Enter.
 */
const TempoInput = ({ value, onChange, min = 40, max = 220 }) => {
    // Local state for the input value (can be invalid/incomplete string)
    const [localValue, setLocalValue] = useState(value.toString());

    // Sync local state if prop changes externally
    useEffect(() => {
        setLocalValue(value.toString());
    }, [value]);

    const commitChange = () => {
        let val = parseInt(localValue, 10);
        if (isNaN(val)) val = 120; // Default fallback

        // Clamp
        const clamped = Math.min(max, Math.max(min, val));

        // Update Parent
        onChange(clamped);

        // Update Local (to reflect clamped value)
        setLocalValue(clamped.toString());
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.target.blur(); // Trigger blur to commit
        }
    };

    const handleBlur = () => {
        commitChange();
    };

    const handleChange = (e) => {
        setLocalValue(e.target.value);
    };

    return (
        <input
            type="number"
            value={localValue}
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            style={{
                background: '#222',
                color: 'var(--color-primary)',
                border: '1px solid #444',
                borderRadius: '4px',
                padding: '4px',
                width: '60px',
                textAlign: 'center',
                fontWeight: 'bold'
            }}
        />
    );
};

export default TempoInput;
